
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud-architect",
      function () {
        return require("private-next-pages/cloud-architect.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cloud-architect"])
      });
    }
  